import './BoxTitle.scss'

interface IBoxTitle {
    title: string
    className?: string
}

function BoxTitle(props: IBoxTitle) {
    const { title, className } = props
    return (
        <div className={`box-title ${className}`}>
            <p className="title">{title}</p>
        </div>
    )
}

export default BoxTitle
